/**
 * Extract cookie based on given cookie name.
 * @param {string} name - The name of the cookie to retrieve
 * @param {string} serverCookies - Optional server-side cookies string
 */
export const getCookie = (name: string, serverCookies?: string) => {
  const parseCookies = (cookieString?: string): string | null => {
    if (cookieString == null) {
      return null
    }

    if (typeof cookieString === 'object') {
      console.error(Error())
    }

    const nameEQ = `${name}=`
    const ca = cookieString.split(';')

    for (let i = 0; i < ca.length; i++) {
      const c = ca[i].trim()
      if (c.indexOf(nameEQ) === 0) {
        const value = c.substring(nameEQ.length)

        return decodeURIComponent(value)
      }
    }

    return null
  }

  if (serverCookies != null) {
    return parseCookies(serverCookies)
  }

  if (typeof window === 'undefined') {
    return null
  }

  return parseCookies(document.cookie)
}
